<template>
  <div class="container-home">
      <!-- <div class="logo"
           @click="toLogin">
        <img class="logoImg"
             :src="logo">
      </div> -->
      <div class="module_bg">
        <img @click="toLogin" class="logo" :src="logo" alt="">
        <p class="title">{{$t('userHome.title1')}}</p>
        <p class="title">{{$t('userHome.title2')}}</p>
      </div>
      <div class="module_container">
        <div class="module_contain" v-if="false">
          <div @click="toBasics" class="module_item">
            <img :src="iconB" alt="">
            <p>{{$t('userHome.basics')}} <img :src="ironLock" alt=""> </p>
          </div>
          <div class="discrb">
            <p>{{$t('userHome.basics_discrb')}}</p>
          </div>
        </div>
        <div class="module_contain">
          <div @click="toAddmission" class="module_item">
            <img :src="iconA" alt="">
            <p>{{$t('userHome.admission')}} <img :src="ironLock" alt="" v-show="disableAdmission"> </p>
          </div>
          <div class="discrb">
            <p>{{$t('userHome.adm_discrb')}}</p>
          </div>
        </div>
        <div class="module_contain" v-if="false">
          <div @click="toCurriculum" class="module_item">
            <img :src="iconC" alt="">
            <p>{{$t('userHome.curriculum')}} <img :src="ironLock" alt="" v-show="disableCurrim"> </p>
          </div>
          <div class="discrb">
            <p>{{$t('userHome.curc_discrb')}}</p>
          </div>
        </div>
        <div class="module_contain">
          <div @click="toInteraction" class="module_item">
            <img :src="iconM" alt="">
            <p>{{$t('userHome.moments')}}   <img :src="ironLock" alt="" v-show="disableInterview"> </p>
          </div>
          <div class="discrb">
            <p>{{$t('userHome.moms_discrb')}}</p>
          </div>
        </div>
        <!-- 直播模块, 需要时放开 -->
        <div class="module_contain">
          <div @click="toLive" class="module_item">
            <img :src="iconL" alt="">
            <p>{{$t('userHome.livestream')}} <img :src="ironLock" alt="" v-show="disableLive"> </p>
          </div>
          <div class="discrb">
            <p>{{$t('userHome.lvs_disscrb')}}</p>
          </div>
        </div>
      </div>
      <!-- <div class="homeBtn addmissionBtn"
           @click="toAddmission">招生系统</div>
      <div class="homeBtn curriculumBtn"
           @click="toCurriculum">备课系统</div>
      <div class="homeBtn interactionBtn"
           @click="toInteraction">家校互动</div> -->

      <div class="basic_enter" v-if="getIsSystemAdmin()" @click="toBasics">
        <img :src="iconB" alt="">
        <p>{{$t('userHome.basics')}}</p>
        <i class="iconfont iconxd-jt-xy-2"></i>
      </div>

      <PublicModel
      v-if="modelTips"
      @closeModel="closeModel"
      :title="''"
      width="80vw"
      >
        <Maintain/>
      </PublicModel>
    </div>
</template>
<script>
// import ApiUrl from '@/config/index.js'
// import logo from '@res/images/home/img_logo.png'
import iconA from '@res/images/home/icon_admission.png'
import iconB from '@res/images/home/icon_base.png'
import iconC from '@res/images/home/icon_curriculum.png'
import iconM from '@res/images/home/icon_moments.png'
import iconL from '@res/images/home/icon_livestream.png'

import PublicModel from '@/views/user/components/public_model'
import Maintain from '@/views/maintain/pages/index'

import ironLock from '@res/images/home/round-lock-24px.png'
import Cookies from 'js-cookie'
import envMode from '@/utils/ajax/http'
import { clientVersion } from '@/utils/env'

export default {
  name: 'home',
  components: {
    PublicModel,
    Maintain
  },
  data () {
    return {
      logo: require('@res/images/home/img_logo.png'),
      iconA,
      iconB,
      iconC,
      iconM,
      iconL,
      ironLock,
      isLook: false,
      isLookjx: false,
      isLookzs: false,
      // 是sis，只开放直播
      isSis: false,
      isPanda: false,
      nodeEnv: '',
      // 关闭招生
      disableAdmission: true,
      // 关闭备课
      disableCurrim: true,
      // 关闭家校互动
      disableInterview: true,
      // 关闭直播
      disableLive: true,

      modelTips: false
    }
  },
  beforeCreate () {
    if (!Cookies.get('tokenInfo', { domain: envMode.env.DOMAIN })) {
      this.$router.push('/login')
    }
  },
  mounted () {
    this.getModuleToggle()
    /**
     * sass环境
     *  东华两个学校开放  家校互动
     *  sis开放直播
     *  isd panda ncic 开放招生
     * panda环境
     *  开放直播, 家校互动
     */
    // let env = this.checkEnv()
    // if (env === 'production') {
    //   if (
    //     location.host.includes('sis') ||
    //     location.host.includes('nis') ||
    //     location.host.includes('his') ||
    //     location.host.includes('panda') ||
    //     location.host.includes('dgtwis') ||
    //     location.host.includes('ncic') ||
    //     location.host.includes('kssi')) {
    //     this.disableLive = false
    //   }
    //   if (
    //     location.host.includes('twik') ||
    //     location.host.includes('dgtwis') ||
    //     location.host.includes('his') ||
    //     location.host.includes('elgenesis') ||
    //     location.host.includes('panda') ||
    //     location.host.includes('nasgz') ||
    //     location.host.includes('kssi')) {
    //     this.disableInterview = false
    //   }
    //   if (location.host.includes('isd') || location.host.includes('panda') || location.host.includes('ncic') || location.host.includes('kssi')) {
    //     this.disableAdmission = false
    //   }
    // }
    // if (env === 'uat') {
    //   this.disableInterview = false
    //   this.disableLive = false
    //   this.disableAdmission = false
    // }
    // if (env === 'release' || env === 'development' || env === 'testing') {
    //   this.disableLive = false
    //   this.disableInterview = false
    //   this.disableAdmission = false
    // }
    // if (env === 'ncic') {
    //   this.disableAdmission = false
    // }
  },
  methods: {
    toLogin () {
      this.$router.push({ path: '/login' })
    },

    closeModel () {
      this.modelTips = false
    },

    // 获取模块开关
    getModuleToggle () {
      this.$request.get('/upms-service/tenant/valid/apps')
        .then(res => {
          console.log(res)
          res.data.map((item) => {
            if (item.baseCode === 'moments' && item.enable) this.disableInterview = false
            if (item.baseCode === 'admissions' && item.enable) this.disableAdmission = false
            if (item.baseCode === 'live' && item.enable) this.disableLive = false
            // if (item.baseCode === 'curriculum' && item.enable) this.disableCurrim = false
          })
        })
    },

    // 去基础模块
    toBasics () {
      window.location.href = envMode.env.ADMIN_URL
    },
    // 招生页面
    async toAddmission () {
      if (this.disableAdmission) {
        this.$message({
          message: this.$t('home.moduleClose'),
          type: 'error'
        })
        return
      }
      if (!await this.hasMaintain(1)) {
        this.modelTips = true
        return
      }
      // eslint-disable-next-line no-unused-vars
      let tokenInfo = Cookies.get('tokenInfo', { domain: envMode.env.DOMAIN })
      tokenInfo = tokenInfo ? JSON.parse(tokenInfo) : ''
      if (tokenInfo && tokenInfo.accountType === 0) window.location.href = `${envMode.env.BASE_URL}?client_version=${clientVersion}`
    },
    // 备课页面
    async toCurriculum () {
      if (this.disableCurrim) {
        this.$message({
          message: this.$t('home.moduleClose'),
          type: 'error'
        })
        return
      }
      if (!await this.hasMaintain(4)) {
        this.modelTips = true
        return
      }
      window.location.href = envMode.env.CURRICULUM_URL
    },
    // 家校互动
    async toInteraction () {
      if (this.disableInterview) {
        this.$message({
          message: this.$t('home.moduleClose'),
          type: 'error'
        })
        return
      }
      if (!await this.hasMaintain(2)) {
        this.modelTips = true
        return
      }
      this.$request.get('/interaction-service/teacher/class/homepage/loginRedirect')
        .then(result => {
          const router = result.data.path
          const recentClass = result.data.recentClass
          if (recentClass.accountRole && recentClass.classDetail) {
            sessionStorage.setItem('classInfo', JSON.stringify(recentClass.classDetail))
            sessionStorage.setItem('authStatus', 0)
          }
          window.location.href = envMode.env.INTERATION_URL + router
        })
    },
    // 直播
    async toLive () {
      if (this.disableLive) {
        this.$message({
          message: this.$t('home.moduleClose'),
          type: 'error'
        })
        return
      }
      if (!await this.hasMaintain(3)) {
        this.modelTips = true
        return
      }
      window.location.href = envMode.env.LIVE_URL
    },
    checkEnv () {
      return process.env.NODE_ENV
    },

    // 获取用户是否是系统管理员
    getIsSystemAdmin () {
      let tokenInfo = Cookies.get('tokenInfo') ? JSON.parse(Cookies.get('tokenInfo')) : {}
      let roles = tokenInfo.roles || []
      return !!roles.find((item) => {
        return item === 'System_Admin'
      })
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.container-home {
  position: relative;
  width: 100%;
  height: 100vh;
  // margin: 100px auto;
  // padding: 0 50px;
  .homeBtn {
    width: 298px;
    height: 191px;
    line-height: 191px;
    box-shadow: 0px 1px 10px 0px rgba(95, 64, 177, 0.2);
    border-radius: 6px;
    font-size: 30px;
    margin: 20px 66px;
    text-align: center;
    float: left;
    cursor: pointer;
    color: rgba(51, 51, 51, 1);
  }
  .module_bg {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 30%;
    background-image: url('../../../resources/images/home/school365_module_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .logo {
      width: auto;
      height: 34px;
      position: absolute;
      top: 30px;
      left: 40px;
      cursor: pointer;
    }
    .title {
      color: #fff;
      font-size: 30px;
    }
  }
  .module_container {
    display: flex;
    // align-items: center;
    justify-content: space-evenly;
    margin: 0 5%;
    margin-top: 3%;
    .module_contain {
      width: 18%;
      display: flex;
      align-items: center;
      // justify-content: center;
      flex-direction: column;
      .module_item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px 0;
        cursor: pointer;
        border:1px solid rgba(243,244,249,1);
        &:hover {
          box-shadow:0px 6px 16px 0px rgba(0, 0, 0, 0.12);
        }
        p {
          color: #33394E;
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-left: 12px;
          }
        }
      }
      .discrb {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        color: #33394E;
        font-size: 14px;
      }
    }
  }
  .addmissionBtn {
    background: url("../../../resources/img/model1@2x.png") bottom right
      no-repeat;
  }
  .curriculumBtn{
    background: url("../../../resources/img/model2@2x.png") bottom right
      no-repeat;
  }
  .interactionBtn{
    background: url("../../../resources/img/img_interaction.png") bottom right
      no-repeat;
  }
  .basic_enter {
    position: absolute;
    right: 60px;
    bottom: 50px;

    display: flex;
    align-items: center;

    cursor: pointer;
    img {
      width: 30px;
    }
    p {
      font-size: 12px;
      text-decoration: underline;
    }
    i {
      font-size: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pages/home.vue